export default __webpack_public_path__ + "static/media/regulasi.81736a06.png";